export default __webpack_public_path__ + "static/media/next.449f506d.jpg";